import {getButtonsForModule} from "./utils";
import _ from "lodash";
import path from "path";
import moment from "moment";
import {adhesionApplicationStatusObjects, paymentMethodOptions, newOrganizationActivities, hasOtherActivity} from "../staticEntities";
import {basicContext} from "../../../utils/contextUtils";
import {decrypt} from "../../../utils/crypto";
import Errors from "../../../utils/Errors";
import crypto from "crypto";
import {generateMembershipDocuments, sendMembershipEmail} from "./membershipFeeUtils";

export const entities = [
    {
        name: 'AdhesionCapacityByAnimalType',
        fields: [
            'AnimalType',
            {path: 'number', type: 'integer'},
        ]
    },
    {
        name: 'AdhesionCapacityByAnimalTypeConfig',
        type: "mongoInternal",
        fields: [
            'animalType',
            {path: 'numberByAnimalType', type: 'object'},
        ]
    },
    {
        name: 'AdhesionShelter',
        fields: [
            {path: 'code', unique: true},
            'name',
            {path: 'status', type: 'EstablishmentStatus'},
            {path: 'types', type: 'ShelterType', link: 'MTM', nullable: true},
            {path: 'animalTypes', type: 'AnimalType', link: 'MTM', nullable: true},
            'address',
            'additionalAddress',
            'zipCode',
            'city',
            {
                path: 'country', ps: {
                    object: [{
                        $u: function () {
                            return 'FRANCE'
                        }
                    }]
                }
            },
            'shelterSchedules',
            {path: 'adhesionCapacityByActivity', type: 'AdhesionCapacityByActivity', link: 'OTM'},
        ]
    },
    {
        name: 'AdhesionCapacityByActivity',
        type: 'mongoInternal',
        fields: [
            'AnimalType',
            {path: 'ddpp', type: 'integer'},
            {path: 'totalCapacity', type: 'integer'},
            {path: 'capacityByActivity', type: 'object'},
        ]
    },
    {
        name: 'Adhesion',
        facets: [
            /* Documents institutionnels */
            {name: 'files', path: 'contactID'},
            {name: 'files', path: 'situationNotice'},
            {name: 'files', path: 'updatedStatus'},
            {name: 'files', path: 'balanceSheetsAndIncomeStatements'},
            {name: 'files', path: 'officialStatement'},
            {name: 'files', path: 'CERFA'},
            {name: 'files', path: 'DDPVisitReports'},
            {name: 'files', path: 'lastGeneralMeeting'},

            /* Documents administratifs */
            {name: 'files', path: 'bnoDeclarationReceipt'},
            {name: 'files', path: 'nonCarnivoreSpeciesActivityDeclaration'},
            {name: 'files', path: 'acacedCertificate'},
            {name: 'files', path: 'adoptionContractAndCommitmentCertificate'},
            {name: 'files', path: 'hostFamilyContract'},
            {name: 'files', path: 'animalEntryExitRegisterExtract'},
            {name: 'files', path: 'icpeDeclarationDogs'},
            {name: 'files', path: 'dogWalkSchedule'},
            {name: 'files', path: 'cerfa15045Receipt'},
            {name: 'files', path: 'breedingRegister'},
            {name: 'files', path: 'animalHoldingLocationDeclaration'},
            {name: 'files', path: 'commitmentAndKnowledgeCertificate'},
            {name: 'files', path: 'animalWelfareOfficerDeclaration'},
            {name: 'files', path: 'gdsFarmSummarySheet'},
            {name: 'files', path: 'openingAuthorizationPrefecture'},
            {name: 'files', path: 'animalHandlingCapacityCertificate'},
            {name: 'files', path: 'transportAuthorization'},

            /* Documents sanitaire*/
            { name: 'files', path: 'healthRegulationFile' },
            { name: 'files', path: 'veterinarySanitaryDeclaration' },
            { name: 'files', path: 'veterinaryAdoptionCertificate' },
            { name: 'files', path: 'lastVeterinaryVisitReport' },
            { name: 'files', path: 'healthMonitoringRegisterExtract' },
            { name: 'files', path: 'selfInspectionStrategy' },
            { name: 'files', path: 'lastIfceInspectionReport' },
            { name: 'files', path: 'prophylaxisOrDdppExemptionReport' },


            {name: 'files', path: 'visitReport'},
            {name: 'files', path: 'documents'},
            'conversations'
        ],
        fields: [
            {path: 'applicationNumber', type: 'string', unique: true},
            {path: 'mail', encrypted: true},
            {path: 'civility', type: 'Civility'},
            {path: 'firstname'},
            {path: 'lastname'},
            {
                path: "fullName",
                fieldPath: ['civility.name', 'firstname', 'lastname'],
                f: function () {
                    return `${this.civility.name} ${this.firstname} ${this.lastname}`
                }
            },
            {path: 'phone', encrypted: true},
            {path: 'organizationPresident', type: 'boolean'},
            {path: 'organizationName'},
            {path: 'organizationAddress'},
            {path: 'organizationAdditionalAddress'},
            {path: 'organizationZipCode'},
            {path: 'organizationCity'},
            {path: 'organizationCountry'},
            {path: "code"},
            {path: "sheltersNumber", type: "integer"},
            {path: 'generalInterestRecognition', type: 'YesNo'},
            {path: 'publicUtilityRecognition', type: 'YesNo'},
            {path: 'hasEndowmentFund', type: 'YesNo'},
            {path: 'hasDUERP', type: 'YesNo'},
            {path: 'DUERPUpdateDate', type: 'date', nullable: true},


            {path: 'employeesNumber', type: 'integer', nullable: true},
            {path: 'electedOfficialsNumber', type: 'integer', nullable: true},
            {path: 'volunteersNumber', type: 'integer', nullable: true},
            {path: 'investigatorsNumber', type: 'integer', nullable: true},
            {path: 'types', type: 'ShelterType', link: 'MTM', nullable: true},
            'otherActivity',
            {path: 'animalTypes', type: 'AnimalType', link: 'MTM'},
            'AnimalTypeGroup',
            {
                type: "AdhesionCapacityByAnimalTypeConfig",
                lazy: true,
                fieldPath: [
                    "adhesionCapacityByAnimalType.id",
                    "adhesionCapacityByAnimalType.animalType.id",
                    "adhesionCapacityByAnimalType.animalType.name",
                    "adhesionCapacityByAnimalType.number"
                ],
                list: true,
                $f: (adhesion, context, callback) => {
                    return callback(
                        null,
                        [
                            adhesion.adhesionCapacityByAnimalType ? adhesion.adhesionCapacityByAnimalType.reduce((acc, cur) => {
                                return {
                                    ...acc,
                                    numberByAnimalType: {
                                        ...acc.numberByAnimalType,
                                        [cur.animalType.name]: cur.number
                                    }
                                }
                            }, {animalType: 'number', numberByAnimalType: {}}) : {animalType: 'number', numberByAnimalType: {}}
                        ]
                    )
                },
                $s: (adhesionCapacityByAnimalTypeConfigs, adhesion, context, callback) => {
                    global.app.C.AnimalType.find({query: {}, fieldPath: ['id', 'name'], ...basicContext(context)}, (e, animalTypes) => {
                        if(e) return callback(e)
                        const numberByAnimalType = adhesionCapacityByAnimalTypeConfigs[0]?.numberByAnimalType
                        const animalTypeNames = numberByAnimalType ? Object.keys(numberByAnimalType): []
                        adhesion.adhesionCapacityByAnimalType =  animalTypeNames.map(animalTypeName => ({
                            animalType: animalTypes.find(animalType => animalType.name === animalTypeName),
                            number: Number(numberByAnimalType[animalTypeName])
                        }))

                        return callback()
                    })
                }
            },
            {
                path: "adhesionCapacityByAnimalType",
                type: "AdhesionCapacityByAnimalType",
                link: {
                    type: 'OTM',
                    onParent: true,
                }
            },
            {type: 'AdhesionShelter', link: 'OTM'},
            {path: 'visitors', type: 'CUser', link: 'MTM', nullable: true},
            {path: 'visitComment', nullable: true},
            {path: 'organizationSize', type: 'Member', nullable: true},
            {path: 'amount', type: 'decimal', nullable: true},
            {path: 'functions', type: 'Function', link: 'MTM', nullable: true},
            {path: 'authorizations', type: 'Profile', link: 'MTM', nullable: true},

            {path: 'membershipExercise', type: 'AdhesionExercice', nullable: true},
            {path: 'exercise', type: 'Exercise', nullable: true},
            {path: 'paymentDate', type: 'date', nullable: true},
            {path: 'paymentMethod', type: 'PaymentMethod', nullable: true},
            {path: 'complementsOrRefusalReason', nullable: true},
            {path: 'status', type: 'AdhesionApplicationStatus'},
            {
                path: "sequence",
                unique: true,
                ps: {
                    object: [{
                        type: "nextSequence",
                        sequenceId: "adhesionApplicationSequence",
                        formatResult: function(result) {
                            return result.toString().padStart(4, '0') // Formats the sequence number, e.g., "0001"
                        }
                    }]
                }
            },
            {
                path: "buttons",
                fieldPath: ['status.id'],
                $f: function (application, context, callback) {
                    const buttons = getButtonsForModule(application, context);
                    callback(null, buttons);
                }
            },
            {
                path: "noDeleteButtonAccess",
                fieldPath: ['status.id'],
                $f: function (application, context, callback) {
                    callback(null, _.get(application, 'status.id') === 'validated');
                }
            },
            {path: 'createdAt', type: 'date'},
        ],
        filters: [
            {
                name: "byUser",
                isDefault: false,
                async: true,
                query: (context, callback) => {
                    global.app.C.CUser.collection.findOne({kpUser: new global.ObjectID(context.user.id)})
                        .then(cUser => {
                            if(!cUser) return callback(null, {_id: null})
                            return callback(null, {mail: cUser.mail})
                        }).catch(e => callback(e))
                }
            }
        ],
        ps: {
            context: [{
                $$u: function (context, callback) {
                    if (this.options.accessType === "S" && context.restAction && context.restAction.crudType === "C") {
                        context.internalFieldPath = [
                            ...new Set([
                                ...context.internalFieldPath,
                                "sequence" // Ensures 'sequence' is included for sequence generation on creation
                            ])
                        ];
                    }
                    callback(null, context)
                }
            }]
        },
        checkAdhesionShelterCodesUnicity: async function(newObject, oldObject, context) {
            const statusId = _.get(oldObject, 'status.id') || _.get(newObject, 'status.id')
            if(statusId === 'rejected') return

            const codes = _.uniq((newObject.adhesionShelters || []).map(shelter => shelter.code).filter(Boolean))
            if(!codes.length) return

            const shelters = await global.app.C.Shelter.find({
                ...basicContext(context),
                fieldPath: [],
                query: {code: {$in: codes}}
            })
            if(!!shelters.length) throw new Errors.ValidationError(`Le N° SIRET ${shelters[0].code} correspond déjà à un établissement existant`)

            const adhesionShelters = await global.app.C.AdhesionShelter.find({
                ...basicContext(context),
                fieldPath: ['code', 'adhesion.id', 'adhesion.status.id'],
                query: {code: {$in: codes}}
            })

            const conflictingShelter = adhesionShelters.find(adhesionShelter =>
                _.get(adhesionShelter, 'adhesion.id') !== newObject.id
                && _.get(adhesionShelter, 'adhesion.status.id') !== 'rejected'
            )
            if(conflictingShelter) throw new Errors.ValidationError(`Le N° SIRET ${conflictingShelter.code} correspond déjà à un établissement d'une autre demande d'adhésion en cours`)
        },
        validateSave: async function(object, oldObject, context, callback) {
            try {
                await this.checkAdhesionShelterCodesUnicity(object, oldObject, context)
            } catch (e) {
                return callback(e)
            }

            const moduleId = _.get(context, 'clientContext.moduleId')
            if(moduleId !== 'm-C-application') return callback()

            const action = context.action
            const actionButton = object.buttons.find(button => button.action === action)

            if(['incomplete', 'incomplete2', 'incomplete3', 'rejected'].includes(actionButton.nextStatus)) {
                if(!object.complementsOrRefusalReason) return callback(new Errors.ValidationError("Vous devez obligatoirement renseigner les compléments demandés / motifs de refus"))
            }

            const params = ['visitValidated', 'visitRejected'].includes(actionButton.nextStatus)
                ? {filter: 'eligibleToVisit', errorMsg: "Action réservée aux utilisateurs avec l'authorisation «Eligible Adhésion - Visite»"}
                : {filter: 'adhesionProcessAdministrator', errorMsg: "Action réservée aux utilisateurs avec l'authorisation «Eligible Adhésion - Administration»"}

            const functions = await global.app.C.Function.find({
                ...basicContext(context),
                query: {},
                fieldPath: ['id'],
                filters: [params.filter]
            })

            const cUser = await global.app.C.CUser.collection.findOne({
                kpUser: new global.ObjectID(context.user.id),
                functions: {$elemMatch: {$in: functions.map(func => new global.ObjectID(func.id))}}
            })
            if(!cUser) return callback(new Errors.ValidationError(params.errorMsg))
            return callback()
        },
        validateDelete: async function(object, context, callback){
            try {
                const adhesion = await global.app.C.Adhesion.get(object.id, {
                    ...basicContext(context),
                    fieldPath: ['status.id']
                })
                if(_.get(adhesion, 'status.id') === 'validated') return callback(new Errors.ValidationError("Vous ne pouvez pas supprimer une demande d'adhésion validée"))
                return callback(null, object)
            } catch (e) {
                return callback(e)
            }
        },
        beforeSave: async (object, oldObject, context, callback) => {
            if (context.restAction && context.restAction.crudType === "C") {
                object.status = {id: 'filed'}

                object.conversations = [{
                    text: "Volet Institutionnel : Enregistré",
                    sender: null,
                    seenBy: [],
                    files: [],
                    timestamp: new Date().toISOString(),
                    from: 'system'
                }]

                const currentYear = new Date().getFullYear()
                object.applicationNumber = `ADHE-${currentYear}-${object.sequence}`
                object.createdAt = new Date()
                return callback(null, object, oldObject)
            }

            const action = context.action
            if(action === 'save') return callback(null, object, oldObject)
            const actionButton = object.buttons.find(button => button.action === action)
            object.status = {id: actionButton.nextStatus}
            if(['incomplete', 'incomplete2', 'incomplete3', 'rejected'].includes(actionButton.nextStatus)) {
                context.complementsOrRefusalReason = object.complementsOrRefusalReason
                object.complementsOrRefusalReason = null
            }
            if(actionButton.nextStatus === 'validated') {
                // Affectation automatique au dernier exercice clôturé des chiffres collectés
                // (capacité, activité et caractéristiques de la structure)
                const closedExercises = await global.app.C.Exercise.find({
                    ...basicContext(context),
                    query: {exerciseStatus: 'finalClosure'},
                    fieldPath: ['id', 'endDate']
                })
                const lastClosedExercise = _.maxBy(closedExercises, exercise => new Date(exercise.endDate))
                object.exercise = lastClosedExercise ? {id: lastClosedExercise.id} : null
            }
            const statusObject = adhesionApplicationStatusObjects.find(status => status.id === object.status.id)
            object.conversations.push({
                text: statusObject.name,
                sender: _.pick(context.user, ['id', 'name']),
                seenBy: [context.user.id],
                files: [],
                timestamp: new Date().toISOString(),
                from: 'system'
            })
            if (context.complementsOrRefusalReason) {
                object.conversations.push({
                    text: context.complementsOrRefusalReason,
                    sender: _.pick(context.user, ['id', 'name']),
                    seenBy: [context.user.id],
                    files: [],
                    timestamp: new Date().toISOString(),
                    from: 'user'
                })
            }
            return callback(null, object, oldObject)
        },
        afterSave: async function(object, oldObject, context, callback){
            const action = context.action
            if(action === 'save') return callback()

            try {
                await this.createUserObject(object, oldObject, context)
                await this.handleMailing(object, context)

                const statusId = _.get(object, 'status.id')
                if(statusId === 'rejected') {
                    await this.deleteUserObject(object, context)
                }

                if(statusId === 'validated') {
                    await this.transferToBusinessModules(object, oldObject, context)
                }

                return callback()
            } catch (error) {
                callback(error)
            }
        },
        afterDelete: async function(object, context, callback){
            await this.deleteUserObject(object, context)
            return callback()
        },
        deleteUserObject: async function(object, context){
            const cUser = await global.app.C.CUser.collection.findOne({mail: object.mail})
            if(cUser) {
                await global.app.C.CUser.delete(
                    cUser._id.toString(),
                    {...basicContext(context)}
                )
            }
        },
        createUserObject: async (object, oldObject, context) => {
            const previousStatus = _.get(oldObject, 'status.id')
            const currentStatus = _.get(object, 'status.id')
            if(previousStatus === 'filed' && ['incomplete', 'preValidated'].includes(currentStatus)) {
                const cUser = await global.app.C.CUser.collection.findOne({mail: object.mail})
                const profile = await global.db.collection('profile').findOne({name: "Dossier d'Adhésion"})

                const authorizations = []
                if(profile) authorizations.push({id: profile._id.toString()})

                if(!cUser) {

                    const buf = crypto.randomBytes(20);

                    const customToken = buf.toString('hex')

                    context.customToken = customToken

                    await global.app.C.CUser.save(
                        {
                            ..._.omit(object, ['id']),
                            username: `${object.firstname}.${object.lastname}`,
                            status: 'waiting',
                            language: {id: 'fr'},
                            active: true,
                            authorizations
                        },
                        {
                            ...basicContext(context),
                            customPasswordInitializationMail: true,
                            customToken,
                            action: 'validate',
                            fieldPath: [
                                'civility.id',
                                'firstname', 'lastname', 'username', 'mail', 'phone', 'language.id',
                                'organizationReferent',
                                'liberalityReferent',
                                'functions.id', 'animalTypes.id',
                                'active', 'status', 'authorizations.id'
                            ]
                        }
                    )
                }
            }
        },
        transferToBusinessModules: async function(object, oldObject, context) {
            const previousStatus = _.get(oldObject, 'status.id')
            const currentStatus = _.get(object, 'status.id')
            if(currentStatus !== 'validated' || previousStatus === 'validated') return

            const adhesion = await global.app.C.Adhesion.get(object.id, {
                ...basicContext(context),
                fieldPath: [
                    'id', 'civility.id', 'firstname', 'lastname', 'phone',
                    'organizationName', 'organizationAddress', 'organizationAdditionalAddress',
                    'organizationZipCode', 'organizationCity', 'code', 'publicUtilityRecognition.id',
                    'types.id', 'otherActivity', 'animalTypes.id', 'organizationSize.id',
                    'membershipExercise.id', 'exercise.id', 'paymentDate', 'amount', 'paymentMethod.id',
                    'functions.id', 'authorizations.id',
                    'adhesionShelters.code', 'adhesionShelters.name', 'adhesionShelters.status.id',
                    'adhesionShelters.types.id', 'adhesionShelters.animalTypes.id',
                    'adhesionShelters.address', 'adhesionShelters.additionalAddress',
                    'adhesionShelters.zipCode', 'adhesionShelters.city',
                    'adhesionShelters.shelterSchedules',
                    'adhesionShelters.adhesionCapacityByActivity.animalType.id',
                    'adhesionShelters.adhesionCapacityByActivity.ddpp',
                    'adhesionShelters.adhesionCapacityByActivity.totalCapacity',
                    'adhesionShelters.adhesionCapacityByActivity.capacityByActivity',
                    'employeesNumber', 'electedOfficialsNumber', 'volunteersNumber', 'investigatorsNumber',
                    'adhesionCapacityByAnimalType.number'
                ]
            })

            // 1. Résolution de l'exercice du membership (current -> ongoing, previous -> exercice précédent)
            const [ongoingExercise] = await global.app.C.Exercise.find({
                ...basicContext(context),
                query: {exerciseStatus: 'ongoing'},
                fieldPath: ['id', 'code', 'startDate']
            })

            let membershipExercise = ongoingExercise
            if(_.get(adhesion, 'membershipExercise.id') === 'previous' && ongoingExercise) {
                const previousExercise = await global.app.C.Exercise.collection
                    .find({startDate: {$lt: ongoingExercise.startDate}})
                    .sort({startDate: -1})
                    .limit(1)
                    .next()
                membershipExercise = previousExercise
                    ? {id: previousExercise._id.toString(), code: previousExercise.code}
                    : null
            }

            // 2. Répartition des montants selon la taille de l'association (P:50, M:100, G:150)
            const expectedAmounts = {'1': 50, '2': 100, '3': 150}
            const expectedAmount = expectedAmounts[_.get(adhesion, 'organizationSize.id')] || 0
            const receivedAmount = Number(adhesion.amount) || 0
            const feeAmount = Math.min(receivedAmount, expectedAmount)
            const donationAmount = Math.max(receivedAmount - expectedAmount, 0)

            const paymentMethodId = _.get(adhesion, 'paymentMethod.id')
            const paymentMethodObject = paymentMethodOptions.find(option => option.id === paymentMethodId)

            // Nb. famille d'accueil = total de la capacité "Famille d'accueil" (hostFamily) de tous les établissements
            const hostFamiliesNumber = (adhesion.adhesionShelters || []).reduce((total, shelter) => {
                return total + (shelter.adhesionCapacityByActivity || []).reduce((sum, cap) => sum + (Number(cap.capacityByActivity?.hostFamily) || 0), 0)
            }, 0)

            // Nb. ACACED = total du nombre de personnes ACACED, toutes espèces confondues
            const acacedNumber = (adhesion.adhesionCapacityByAnimalType || []).reduce((total, cap) => total + (cap.number || 0), 0)

            // 3. Génération des documents de cotisation (carte de membre + justificatif)
            //    L'objet "contribution" et l'organisation minimale alimentent les PDF puis le mail.
            const contribution = {
                exercise: {code: _.get(membershipExercise, 'code')},
                amount: receivedAmount,
                feeAmount,
                donationAmount,
                paymentDate: adhesion.paymentDate,
                paymentMethod: paymentMethodObject ? {name: paymentMethodObject.name} : null,
                organizationReferents: [{
                    firstname: adhesion.firstname,
                    mail: object.mail && decrypt(object.mail)
                }]
            }
            const organizationForDocuments = {
                code: adhesion.code,
                name: adhesion.organizationName,
                address: adhesion.organizationAddress,
                additionalAddress: adhesion.organizationAdditionalAddress,
                zipCode: adhesion.organizationZipCode,
                city: adhesion.organizationCity
            }

            const {cardFile, statementFile} = await generateMembershipDocuments(contribution, organizationForDocuments)

            const addMetaDataToFile = file => ({
                ...file,
                date: moment().format("YYYY-MM-DD HH:mm"),
                user: _.pick(context.user, ['id', 'name']),
                group: _.pick(context.group, ['id', 'name'])
            })

            const membership = {
                exercise: membershipExercise ? {id: membershipExercise.id} : null,
                status: {id: 'settled'},
                amount: receivedAmount,
                feeAmount,
                donationAmount,
                paymentDate: adhesion.paymentDate,
                paymentMethod: paymentMethodId ? {id: paymentMethodId} : null,
                sendingCounter: 1,
                membershipCard: cardFile,
                accountStatement: statementFile,
                lastModificationUser: {id: context.user.id, name: context.user.name},
                lastModificationDate: new Date()
            }

            // 3. Création de l'organisation (type association) avec la cotisation
            await global.app.C.Organization.save(
                {
                    organizationType: {id: 'association'},
                    code: adhesion.code,
                    name: adhesion.organizationName,
                    tradingName: adhesion.organizationName,
                    rna: "X",
                    rup: _.get(adhesion, 'publicUtilityRecognition.id') ? {id: adhesion.publicUtilityRecognition.id} : null,
                    activities: (adhesion.types || []).map(type => ({id: type.id})),
                    otherActivity: hasOtherActivity(adhesion.types) ? adhesion.otherActivity : '',
                    animalTypes: (adhesion.animalTypes || []).map(animalType => ({id: animalType.id})),
                    status: {id: 'member'},
                    member: _.get(adhesion, 'organizationSize.id') ? {id: adhesion.organizationSize.id} : null,
                    address: adhesion.organizationAddress,
                    additionalAddress: adhesion.organizationAdditionalAddress,
                    zipCode: adhesion.organizationZipCode,
                    city: adhesion.organizationCity,
                    country: 'France',
                    files: [addMetaDataToFile(cardFile), addMetaDataToFile(statementFile)],
                    organizationDetails: adhesion.exercise ? [{
                        exercise: {id: adhesion.exercise.id},
                        administratorsNumber: adhesion.electedOfficialsNumber || 0,
                        employeesNumber: adhesion.employeesNumber || 0,
                        volunteersNumber: adhesion.volunteersNumber || 0,
                        investigatorsNumber: adhesion.investigatorsNumber || 0,
                        hostFamiliesNumber,
                        ACACEDNumber: acacedNumber
                    }] : [],
                    organizationMemberships: [membership]
                },
                {
                    ...basicContext(context),
                    fieldPath: [
                        'organizationType.id', 'code', 'name', 'tradingName', 'rna',
                        'rup.id', 'activities.id', 'otherActivity', 'animalTypes.id', 'status.id', 'member.id',
                        'address', 'additionalAddress', 'zipCode', 'city', 'country',
                        'files',
                        'organizationDetails.exercise.id',
                        'organizationDetails.administratorsNumber', 'organizationDetails.employeesNumber',
                        'organizationDetails.volunteersNumber', 'organizationDetails.investigatorsNumber',
                        'organizationDetails.hostFamiliesNumber', 'organizationDetails.ACACEDNumber',
                        'organizationMemberships.exercise.id', 'organizationMemberships.status.id',
                        'organizationMemberships.amount', 'organizationMemberships.feeAmount', 'organizationMemberships.donationAmount',
                        'organizationMemberships.paymentDate', 'organizationMemberships.paymentMethod.id',
                        'organizationMemberships.sendingCounter',
                        'organizationMemberships.membershipCard.id', 'organizationMemberships.membershipCard.filename',
                        'organizationMemberships.accountStatement.id', 'organizationMemberships.accountStatement.filename',
                        'organizationMemberships.lastModificationUser.id', 'organizationMemberships.lastModificationDate'
                    ]

                }
            )

            // Récupération de l'organisation créée (code = N° SIREN, unique)
            const createdOrganization = await global.app.C.Organization.collection.findOne({code: adhesion.code})
            if(!createdOrganization) return
            const organizationId = createdOrganization._id.toString()

            // 4. Création des établissements rattachés à l'organisation
            for(const shelter of (adhesion.adhesionShelters || [])) {
                await global.app.C.Shelter.save(
                    {
                        organization: {id: organizationId},
                        code: shelter.code,
                        name: shelter.name,
                        status: _.get(shelter, 'status.id') ? {id: shelter.status.id} : null,
                        types: (shelter.types || []).map(type => ({id: type.id})),
                        animalTypes: (shelter.animalTypes || []).map(animalType => ({id: animalType.id})),
                        address: shelter.address,
                        additionalAddress: shelter.additionalAddress,
                        zipCode: shelter.zipCode,
                        city: shelter.city,
                        shelterSchedules: shelter.shelterSchedules,
                        country: 'France'
                    },
                    {
                        ...basicContext(context),
                        fieldPath: [
                            'organization.id', 'code', 'name', 'status.id',
                            'types.id', 'animalTypes.id', 'address', 'additionalAddress',
                            'zipCode', 'city', 'shelterSchedules', 'country'
                        ]
                    }
                )
            }

            // 5. Création des capacités par établissement à partir des données de l'adhésion
            const adhesionShelters = adhesion.adhesionShelters || []

            if(adhesionShelters.length > 0 && adhesion.exercise) {
                for(const adhesionShelter of adhesionShelters) {
                    const createdShelter = await global.app.C.Shelter.collection.findOne({
                        organization: createdOrganization._id,
                        code: adhesionShelter.code
                    })
                    if(!createdShelter) continue

                    const shelterActivityIds = (adhesionShelter.types || []).map(t => t.id)

                    for(const cap of (adhesionShelter.adhesionCapacityByActivity || [])) {
                        const activityUpdates = newOrganizationActivities.reduce((acc, activity) => {
                            if(!shelterActivityIds.includes(activity.id)) return {...acc, [activity.id]: 0}
                            return {...acc, [activity.id]: cap.capacityByActivity?.[activity.id] || 0}
                        }, {})

                        await global.db.collection('c.capacity').updateOne(
                            {
                                shelter: createdShelter._id,
                                exercise: new global.ObjectID(adhesion.exercise.id),
                                animalType: new global.ObjectID(cap.animalType.id),
                                group: new global.ObjectID(context.group.id)
                            },
                            {
                                $set: {
                                    shelter: createdShelter._id,
                                    exercise: new global.ObjectID(adhesion.exercise.id),
                                    animalType: new global.ObjectID(cap.animalType.id),
                                    totalCapacity: cap.totalCapacity || 0,
                                    ddpp: cap.ddpp || 0,
                                    ...activityUpdates,
                                    group: new global.ObjectID(context.group.id)
                                }
                            },
                            { upsert: true }
                        )
                    }
                }
            }

            // 6. Mise à jour du contact existant (CUser créé en amont) et rattachement à l'organisation
            const cUser = await global.app.C.CUser.collection.findOne({mail: object.mail})
            if(!cUser) return

            const userFieldPath = [
                'id', 'civility.id', 'firstname', 'lastname', 'mail', 'phone',
                'active', 'status', 'language.id', 'superCom_',
                'organizationReferent', 'liberalityReferent',
                'functions.id', 'authorizations.id', 'organization.id'
            ]

            const contact = await global.app.C.CUser.get(cUser._id.toString(), {
                ...basicContext(context),
                fieldPath: userFieldPath
            })

            contact.organization = {id: organizationId}
            contact.organizationReferent = true
            contact.active = true
            contact.functions = (adhesion.functions || []).map(f => ({id: f.id}))
            contact.authorizations = (adhesion.authorizations || []).map(a => ({id: a.id}))

            await global.app.C.CUser.save(contact, {
                ...basicContext(context),
                fieldPath: userFieldPath
            })

            // 7. Envoi de la carte de membre + justificatif au président (unique référent)
            await sendMembershipEmail(
                contribution,
                {name: adhesion.organizationName},
                {cardFile, statementFile},
                context
            )
        },
        handleMailing: async (object, context) => {
            let mails = []

            //Prepare email to notify the submitter
            const notificationEmail = prepareNotificationEmail(object, context)

            if(notificationEmail) mails.push(notificationEmail)

            const status = _.get(object, 'status.id')

            if(['filed', 'filed2', 'updated', 'updated2', 'filed3', 'updated3'].includes(status)) {
                const administrationEmails = await prepareAdministrationEmails(object, context)
                administrationEmails.forEach(mail => mails.push(mail))
            }

            if(status === 'visitInProgress') {
                const visitorsEmails = await prepareVisitEmails(object, context)
                visitorsEmails.forEach(mail => mails.push(mail))
            }

            if(status === 'validated') {
                const internalOrganizationEmails = await prepareInternalOrganizationEmails(object, context)
                internalOrganizationEmails.forEach(mail => mails.push(mail))
            }

            return global.mailer.sendMail(mails, (error) => {
                if(error) console.log(error)
            })
        }

    }

]

function prepareDefaultMail() {
    return {
        from: `"CNDA - Processus Adhésion"adhesion@defensedelanimal.fr`,
        replyTo: "adhesion@defensedelanimal.fr",
        templateDir: path.join(global.appRoot, global.isProd ? 'buildServer' : 'src' , '/server/models/cnda/adhesion/templates'),
        verbose: {
            general: true,
        }
    }
}

function getNotificationEmailContent(object) {
    let content = {}
    const status = _.get(object, 'status.id')
    switch (status) {
        case 'filed':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Enregistré`
            content.template = 'user_submission_filed.html'
            break
        case 'incomplete':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Compléments  demandés`
            content.template = 'user_submission_incomplete.html'
            break
        case 'updated':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Mis à jour`
            content.template = 'user_submission_updated.html'
            break
        case 'preValidated':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Validé`
            content.template = 'user_submission_preValidated.html'
            break
        case 'filed2':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Enregistré`
            content.template = 'user_submission_filed2.html'
            break
        case 'incomplete2':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Compléments  demandés`
            content.template = 'user_submission_incomplete2.html'
            break
        case 'updated2':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Mis à jour`
            content.template = 'user_submission_updated2.html'
            break
        case 'validated2':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Validé`
            content.template = 'user_submission_validated2.html'
            break

        case 'filed3':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Enregistré`
            content.template = 'user_submission_filed3.html'
            break
        case 'incomplete3':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Compléments  demandés`
            content.template = 'user_submission_incomplete3.html'
            break
        case 'updated3':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Mis à jour`
            content.template = 'user_submission_updated3.html'
            break

        case 'completed':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Validé`
            content.template = 'user_submission_completed.html'
            break
        case 'visitInProgress':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Visite : Demandée`
            content.template = 'user_submission_visitInProgress.html'
            break
        case 'accepted':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Adhésion : Acceptée`
            content.template = 'user_submission_accepted.html'
            break
        case 'validated':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Adhésion : Validée`
            content.template = 'user_submission_validated.html'
            break
        case 'rejected':
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Adhésion : Refusée`
            content.template = 'user_submission_rejected.html'
            break
    }
    return content
}

function prepareNotificationEmail(object, context) {
    const defaultMail = prepareDefaultMail()
    const content = getNotificationEmailContent(object, context)

    if(!content.template) return null

    const statusId = _.get(object, "status.id")
    const groupModelId = _.get(context, "groupModel.id", "")

    let amount = 0

    const organizationSize = _.get(object, "organizationSize.id")

    switch (organizationSize) {
        case '1':
            amount = 50
            break
        case '2':
            amount = 100
            break
        case '3':
            amount = 150
            break
    }

    const mediaDirPath = path.join(global.appRoot, global.isProd ? 'buildServer' : 'src' , '/server/models/cnda/media')

    const bankIdentityStatement = statusId === 'accepted'
        ? [{path: mediaDirPath + '/RIB_ADHESIONS.pdf'}]
        : []

    return _.defaults({
        to: decrypt(object.mail),
        content: content.template,
        subject: { template: content.subject },
        context: {
            firstname: object.firstname,
            applicationNumber: object.applicationNumber,
            organization: object.organizationName,
            lastComment: context.complementsOrRefusalReason || object.complementsOrRefusalReason,
            exerciceLabel: _.get(object, 'membershipExercise.id') === 'previous' ? 'précédente' : 'en cours',
            host: context.host,
            amount,
            visitors: object.visitors?.map(visitor => visitor.completeInfo),
            baseUrl: global.isProd
                ? `https://${context.host}`
                : `http://localhost:3000`,
            groupModelUrl: global.isProd
                ? `https://${context.host}/business/${groupModelId}`
                : `http://localhost:3000/business/${groupModelId}`,
            tokenPresent: !!context.customToken,
            tokenAbsent: !context.customToken,
            customToken: context.customToken
        },
        attachments: [...bankIdentityStatement]
    }, defaultMail)
}

async function prepareAdministrationEmails(object, context) {
    const defaultMail = prepareDefaultMail()
    const recipients = await getAdministrators(context)
    const content = {}

    const status = _.get(object, 'status.id')

    switch (status) {
        case 'filed':
            content.template = 'admin_submission_filed.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Enregistré`
            break
        case 'updated':
            content.template = 'admin_submission_updated.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Institutionnel : Mis à jour`
            break
        case 'filed2':
            content.template = 'admin_submission_filed2.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Enregistré`
            break
        case 'updated2':
            content.template = 'admin_submission_updated2.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Administratif : Mis à jour`
            break
        case 'filed3':
            content.template = 'admin_submission_filed3.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Enregistré`
            break
        case 'updated3':
            content.template = 'admin_submission_updated3.html'
            content.subject = `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Volet Sanitaire : Mis à jour`
            break
    }

    return recipients.map(recipient => {
        return _.defaults(
            {
                to: decrypt(recipient.mail),
                content: content.template,
                subject: { template: content.subject },
                context: {
                    firstname: recipient.firstname,
                    applicationNumber: object.applicationNumber,
                    organization: object.organizationName
                }
            },
            defaultMail
        )
    })
}

async function prepareVisitEmails(object, context) {
    const defaultMail = prepareDefaultMail()
    const recipients = await getVisitors(object, context)
    const civility = _.get(object, 'civility.name', '')
    const mail = object.mail && decrypt(object.mail)
    const phone = object.phone && decrypt(object.phone)
    const applicantInfo = `${context.tc(civility)} ${object.firstname} ${object.lastname}, Courriel : ${mail} et Téléphone : ${phone}`
    // a contact may have no mail: nothing to send them
    return recipients.filter(recipient => !!recipient.mail).map(recipient => {
        return _.defaults(
            {
                to: decrypt(recipient.mail),
                content: 'visitor_submission_visitInProgress.html',
                subject: { template: `CNDA - Demande d'ahésion N° ${object.applicationNumber} : Visite : Demandée` },
                context: {
                    firstname: recipient.firstname,
                    applicationNumber: object.applicationNumber,
                    applicant: applicantInfo,
                    organization: object.organizationName
                }
            },
            defaultMail
        )
    })
}

async function prepareInternalOrganizationEmails(object, context) {
    const defaultMail = prepareDefaultMail()
    const recipients = await getInternalOrganizationUsers(context)
    return recipients.map(recipient => {
        return _.defaults(
            {
                to: decrypt(recipient.mail),
                content: 'new_member_admission.html',
                subject: { template: `Nouvelle association admise à la CNDA : ${object.organizationName}` },
                context: {
                    organizationName: object.organizationName
                }
            },
            defaultMail
        )
    })
}

async function getAdministrators(context) {
    const functions = await global.app.C.Function.find({
        ...basicContext(context),
        query: {},
        fieldPath: ['id'],
        filters: ['adhesionProcessAdministrator']
    })

    return await global.app.C.CUser.find({
        ...basicContext(context),
        query: {functions: {$elemMatch: {$in: functions.map(func => new global.ObjectID(func.id))}}},
        fieldPath: ['id', 'firstname', 'mail']
    })
}

async function getVisitors(object, context) {

    return await global.app.C.CUser.find({
        ...basicContext(context),
        query: {_id: {$in: object.visitors.map(visitor => new global.ObjectID(visitor.id))}},
        fieldPath: ['id', 'firstname', 'mail']
    })
}

async function getInternalOrganizationUsers(context) {
    const internalOrganizations = await global.app.C.Organization.find({
        ...basicContext(context),
        query: {organizationType: 'internal'},
        fieldPath: ['id']
    })
    if(!internalOrganizations.length) return []

    return await global.app.C.CUser.find({
        ...basicContext(context),
        query: {organization: {$in: internalOrganizations.map(organization => new global.ObjectID(organization.id))}},
        fieldPath: ['id', 'mail'],
        filters: ['isActive']
    })
}
